module.exports = __webpack_public_path__ + "img/borchia_5.d782a5c2.svg";